<template>
  <div class="col-md-12 well repeatable-element row m-1 p-2">
    <div class="controls">
      <button type="button" class="close" @click="$emit('on-remove')">
        <span aria-hidden="true">×</span>
      </button>
    </div>

    <!-- hidden input -->
    <div
      class="hidden"
      element="div"
      bp-field-wrapper="true"
      bp-field-name="agendas.0.id"
      bp-field-type="hidden"
    >
      <input
        type="hidden"
        :name="`groups[${index}][prices][${priceIndex}][id]`"
        :value="price.id"
        class="form-control"
        data-repeatable-input-name="id"
        data-row-number="1"
        change-event-applied="true"
      />
    </div>
    <!-- html5 date input -->

    <div class="col-12 mb-4" element="div">
      <label>Nieuwe prijs</label>
      <input
        type="text"
        :name="`groups[${index}][prices][${priceIndex}][value]`"
        v-model="price.value"
        class="form-control"
      />
    </div>

    <div class="col-12 col-md-6 mb-4" element="div">
      <label>Datum vanaf</label>
      <input
        type="date"
        :name="`groups[${index}][prices][${priceIndex}][start_date]`"
        v-model="price.start_date"
        class="form-control"
        validation="required"
      />
    </div>

    <div class="col-12 col-md-6 mb-4" element="div">
      <label>Tot en met</label>
      <input
        type="date"
        :name="`groups[${index}][prices][${priceIndex}][end_date]`"
        v-model="price.end_date"
        class="form-control"
        validation="required"
      />
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "Price",
  props: {
    modelValue: {
      type: Object,
    },
    index: {
      type: Number,
    },
    priceIndex: {
      type: Number,
    },
  },
  data() {
    return {
      price: {
        ...this.modelValue,
        start_date: this.formatDate(this.modelValue.start_date),
        end_date: this.formatDate(this.modelValue.end_date),
      },
    };
  },
  methods: {
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
  },
  watch: {
    price: {
      immediate: false,
      deep: true,
      handler(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
};
</script>
